import { Key } from '@briebug/ngrx-auto-entity';

export class EquipmentModel {
    @Key id: number;
    equipMake: string;
    equipModel: string;
    equipType: number;
}